import React from "react";
import { Helmet } from "react-helmet";
import IndexView from "./webflow/IndexView";

function IndexController(props) {
  return (
    <>
      <Helmet>
        <title>Roxane Solaris</title>
        <meta
          content="The Solar Express, an e-book for kids to learn about the solar system, in Spanish and English."
          name="description"
        />
        <meta content="Roxane Solaris" property="og:title" />
        <meta
          content="The Solar Express, an e-book for kids to learn about the solar system, in Spanish and English."
          property="og:description"
        />
        <meta
          content="https://roxanesolaris-public.s3.amazonaws.com/roxanesolaris-opengraph.png"
          property="og:image"
        />
        <meta content="Roxane Solaris" property="twitter:title" />
        <meta
          content="The Solar Express, an e-book for kids to learn about the solar system, in Spanish and English."
          property="twitter:description"
        />
        <meta
          content="https://roxanesolaris-public.s3.amazonaws.com/roxanesolaris-opengraph.png"
          property="twitter:image"
        />
        <meta property="og:type" content="website" />
        {/* <link rel="canonical" href="http://mysite.com/example" /> */}
      </Helmet>
      <IndexView>{/* <myform {...props} /> */}</IndexView>
    </>
  );
}

export default IndexController;
